import setIsProgressiveRendering from "../actions/setIsProgressiveRendering";
import { InstrumentationService } from "sh-services";
import { mutator } from "satcheljs";

/**
 * Sets the boolean to indicate progressive rendering is in progress
 * @param inProgress - boolean indicating if progressive rendering is in progess
 */
export default mutator(setIsProgressiveRendering, ({ viewState, inProgress, didComplete }) => {
    // check if progressive render is already in progress
    if (inProgress && viewState.isProgressiveRendering) {
        InstrumentationService.logDataProgressiveRenderEnded(false /* didComplete */);
        viewState.progressiveRenderEndTimestamp = new Date().getTime();
    }

    if (inProgress) {
        // mark the time of the start
        InstrumentationService.setProgressiveRenderStarted();
        viewState.progressiveRenderStartTimestamp = new Date().getTime();
        // clear the end time
        viewState.progressiveRenderEndTimestamp = -1;
        // reset groups and members in view since we are starting over
        viewState.groupsInView = [];
        viewState.membersInView = [];
    } else if (viewState.isProgressiveRendering) {
        // mark the end time of the progressive rendering
        InstrumentationService.logDataProgressiveRenderEnded(didComplete);
        viewState.progressiveRenderEndTimestamp = new Date().getTime();
    }
    viewState.isProgressiveRendering = inProgress;
});